import React from 'react';

/**
 * Like Array.prototype.join but allows sep or elements of xs to be jsx.
 * @param  {array}       xs    Array of strings or jsx elements.
 * @param  {string|node} sep   A string or node to put between every element of xs.
 * @return {node}              A span containing every element of xs interspersed with sep.
 */
export function join(xs, sep) {
  let output = xs.reduce((acc, x, i, arr) => {
    acc.push(x);
    if (i !== arr.length - 1) {
      acc.push(sep);
    }
    return acc;
  }, []);

  return <React.Fragment>{output}</React.Fragment>;
}

/**
 * Like String.prototype.replace but allows replace to be a jsx node or a string.
 * @param  {string}       string    String to replace from.
 * @param  {string}       find      Value to find in string.
 * @param  {string|node}  replace   A string or a node to replace find with.
 * @return {node}                   A span containing string with every instance of find replaced by replace.
 */
export function replace(string, find, replace) {
  return join((string || '').split(find), replace);
}
